"use strict";

/**
 * Parallax JS
 * Manages parallax effects
 *
 * @author Alexander Borunski
 */

(function ($, Parallax) {

    var loaded = false;
    var parallaxElements = [];

    $(document).on("zp-load", function () {
        zp_init();
    });

    function zp_init() {

        var parallaxElementDiv = $('.zp_parallax').not('.zp_loaded');

        parallaxElementDiv.each(function (index, element) {

            var root = $(element);
            root.addClass('zp_loaded');
            var parallax = new Parallax(root);
            parallaxElements.push(parallax);
        });

        if (!loaded) {
            $(document).on("zp-unload", zp_unload);
            loaded = true;
        }
    }

    function zp_unload() {
        $.each(parallaxElements, function (index, parallaxElement) {
            parallaxElement.unload();
        });
        parallaxElements = [];
    }

})(jQuery, Parallax);